import { PropertyListingItemModel } from '@_types/organisms';
import Button from '@atoms/buttons/Button';
import Picture from '@atoms/pictures/Picture';
import { getModifiers } from '@helpers/functions';

export default function PropertyListingItem(model: PropertyListingItemModel) {
  const { image, title, subtitle, description, iconList, pricePrefix, price, isSold, priceSuffix, cta, url, tagList, dataJson } = model;
  const styleModifiers = getModifiers(model, 'kf-o-property-listing-item');

  return (
    <div className={styleModifiers}>
      <div className="kf-o-property-listing-item__image">
        {tagList && !isSold && (
          <div className="kf-o-property-listing-item__tag-list">
            {tagList.map((tag, index) => (
              <span key={index} className="kf-o-property-listing-item__tag">
                {tag}
              </span>
            ))}
          </div>
        )}
        <Picture {...image} />
        {isSold && <span className="kf-o-property-listing-item__sold">Sold</span>}
      </div>
      <div className="kf-o-property-listing-item__content">
        <div className="kf-o-property-listing-item__content--top">
          {isSold && <div className="kf-o-property-listing-item__content__sold">Sold</div>}
          <h5 className="kf-o-property-listing-item__title">
            {cta ? (
              title
            ) : (
              <a className="kf-o-property-listing-item__title-link" data-json={JSON.stringify(dataJson)} href={url}>
                {title}
              </a>
            )}
          </h5>
          <p className="kf-o-property-listing-item__subtitle">{subtitle}</p>
          <p className="kf-o-property-listing-item__description">{description}</p>
        </div>
        <div className="kf-o-property-listing-item__content--bottom">
          {iconList && (
            <div className="kf-o-property-listing-item__icon-list">
              {iconList.map((icon, index) => (
                <div key={index} className="kf-o-property-listing-item__icon-list-item" title={icon.iconName}>
                  <Picture {...icon.icon} />
                  <span>{icon?.text}</span>
                </div>
              ))}
            </div>
          )}
          <div className="kf-o-property-listing-item__price">
            {pricePrefix && <span className="kf-o-property-listing-item__price-prefix">{pricePrefix}</span>}
            <span className="kf-o-property-listing-item__price-value">{price}</span>
            {priceSuffix && <span className="kf-o-property-listing-item__price-suffix">{priceSuffix}</span>}
          </div>

          {cta && (
            <Button
              {...cta}
              dataSet={{
                'data-json': JSON.stringify(dataJson),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
